export default __webpack_public_path__ + "static/media/Lg_Logo.46e7527e.png";